
export class TipoCdCentrusRecebido {

  constructor(
    public processoRecuperarSenha?: number,
    public alterarSenhaQuandoLogado?: number
) { }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/dominios/tipo-cdCentrus-recebido.ts